import { memo } from 'react';
import classNames from 'classnames';
import { v4 as uuidv4 } from 'uuid';

import {
  isHeaderItem,
  isValueItem,
  ListReservedValues,
} from '@xemplo/stateful-list-core';

import { ListMode } from '../../utils/types/stateful-list.types';
import * as S from '../common/common.styles';
import ListItemMulti from '../item/list-item-multi';
import ListItemSingle from '../item/list-item-single';
import ListItemTags from '../item/list-item-tags';

import { ItemListRendererProps } from './item-list-renderer.types';

function itemFactory(mode: ItemListRendererProps['mode']) {
  switch (mode) {
    case ListMode.Single:
      return ListItemSingle;
    case ListMode.Multi:
      return ListItemMulti;
    case ListMode.Tags:
      return ListItemTags;
    default:
      throw new Error(`Unsupported list mode: ${mode}`);
  }
}

export const ItemListRenderer = memo(({ groups, mode }: ItemListRendererProps) => {
  return (
    <>
      {groups.map((group, groupIndex) => {
        const groupId = `group-header-${groupIndex}`;
        const Component = itemFactory(mode);

        // Find the first header in the group (if any)
        const headerItem = group.items.find(isHeaderItem);

        return (
          <div key={groupIndex}>
            {headerItem && (
              <S.ListHeader id={groupId} role="presentation">
                <S.ListItemText title={headerItem.label}>
                  {headerItem.label}
                </S.ListItemText>
              </S.ListHeader>
            )}

            <S.ListGroup role="group" aria-labelledby={headerItem ? groupId : undefined}>
              {group.items.filter(isValueItem).map((item) => (
                <Component key={`${uuidv4()}-${item.focusId}`} item={item}>
                  <S.ListItemText
                    title={item.label}
                    className={classNames({
                      tags: mode === ListMode.Tags,
                      'no-result': item.value === ListReservedValues.noResult,
                    })}
                  >
                    {item.label}
                  </S.ListItemText>
                </Component>
              ))}
            </S.ListGroup>
          </div>
        );
      })}
    </>
  );
});
